module.exports = __webpack_public_path__ + "static/img/40002 (4).4cf25c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40002 (4).jpg
// module id = eAPp
// module chunks = 14